export default __webpack_public_path__ + "static/media/Nihilistic Slippers.bda39809.jpg";